//Imports node_modules
import React from 'react'
import { Routes, Route } from 'react-router-dom'

//Imports Css
import './Content.css'

//Imports Components
import UserPage from '../views/pages/userPage/UserPage'
import VerefyIdPage from '../views/pages/verefyIdPage/VerefyIdPage'
import ZonePage from '../views/pages/zonePage/ZonePage'
import ProductionPage from '../views/pages/productionPage/ProductionPage'
import ProductionWorkListPage from '../views/pages/productionWorkListPage/ProductionWorkListPage'
import GroupProductionPage from '../views/pages/groupProductionPage/GroupProductionPage'

const Content = props => (
    <main className="Content">
        <Routes>
            <Route path="/userPage" element={<UserPage />}></Route>
            <Route path="/verefyId" element={<VerefyIdPage />}></Route>
            <Route path="/zonePage" element={<ZonePage></ZonePage>}></Route>
            <Route path="/productionPage" element={<ProductionPage></ProductionPage>}></Route>
            <Route path="/productionWorkListPage" element={<ProductionWorkListPage></ProductionWorkListPage>}></Route>
            <Route path="/groupProductionPage" element={<GroupProductionPage></GroupProductionPage>}></Route>
            <Route path="/" element={<VerefyIdPage />}></Route>
            <Route path="" element={<VerefyIdPage ></VerefyIdPage>}></Route>
        </Routes>
    </main>
)

export default Content